import React from 'react';
import PropTypes from 'prop-types';
import { BaseText } from './style';
import * as Constant from 'constant';

Text.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOf([
    Constant.SIZE.xxs,
    Constant.SIZE.xs,
    Constant.SIZE.small,
    Constant.SIZE.medium,
    Constant.SIZE.large,
    Constant.SIZE.xl,
    Constant.SIZE.xxl,
    Constant.SIZE._3xl,
    Constant.SIZE._4xl,
    Constant.SIZE._5xl,
  ]),
  ellipsis: PropTypes.bool,
  bold: PropTypes.bool,
  preWrap: PropTypes.bool,
  display: PropTypes.string,
  underline: PropTypes.bool,
  onHover: PropTypes.arrayOf(PropTypes.string), //TEXT_DECORATION.bold, TEXT_DECORATION.underline
  onClick: PropTypes.func,
  textCase: PropTypes.oneOf([
    Constant.TEXT.capitalize,
    Constant.TEXT.lowercase,
    Constant.TEXT.uppercase,
  ]),
  withWordBreak: PropTypes.bool,
  lineClamp: PropTypes.number,
  dataTestId: PropTypes.string,
};
Text.defaultProps = {
  size: Constant.SIZE.medium,
  ellipsis: false,
  bold: false,
  preWrap: false,
  underline: false,
  withWordBreak: true,
  lineClamp: 0,
  dataTestId: 'text',
};

function Text(props) {
  const wordBreak = props.withWordBreak ? 'break-word' : '';
  let fontSize;
  let fontFamily = 'arimo, arial';
  let whiteSpace;
  let overflow;
  let textOverflow;
  let fontWeight = 400;
  let textDecoration = null;
  let hoverStyle = null;
  let cursor = null;
  let lineHeight;

  if (props.bold) {
    fontWeight = 700;
  }

  if (props.onClick) {
    cursor = 'pointer';
  }

  if (props.underline) {
    textDecoration = Constant.TEXT_DECORATION.underline;
  }

  if (props.preWrap) {
    whiteSpace = 'pre-wrap';
  } else if (props.ellipsis && !props.lineClamp) {
    whiteSpace = 'nowrap';
    overflow = 'hidden';
    textOverflow = 'ellipsis';
  }

  if (props.onHover) {
    hoverStyle = '';
    if (props.onHover.indexOf(Constant.TEXT_DECORATION.underline) >= 0) {
      hoverStyle += `text-decoration: underline;`;
    }
    if (props.onHover.indexOf(Constant.TEXT_DECORATION.bold) >= 0) {
      hoverStyle += `font-weight: bold;`;
    }
  }

  switch (props.size) {
    case Constant.SIZE.xxs:
      fontSize = 12;
      lineHeight = 16;
      break;
    case Constant.SIZE.xs:
      fontSize = 13;
      lineHeight = 17;
      break;
    case Constant.SIZE.small:
      fontSize = 14;
      lineHeight = 20;
      break;
    case Constant.SIZE.medium:
      fontSize = 15;
      lineHeight = 20;
      break;
    case Constant.SIZE.large:
      fontSize = 16;
      lineHeight = 24;
      break;
    case Constant.SIZE.xl:
      fontSize = 18;
      lineHeight = 24;
      break;
    case Constant.SIZE.xxl:
      fontSize = 20;
      lineHeight = 24;
      break;
    case Constant.SIZE._3xl:
      fontSize = 24;
      lineHeight = 28;
      break;
    case Constant.SIZE._4xl:
      fontSize = 28;
      lineHeight = 32;
      break;
    case Constant.SIZE._5xl:
      fontSize = 32;
      lineHeight = 38;
      break;
    default:
      fontSize = 14;
      break;
  }

  return (
    <BaseText
      fontSize={fontSize}
      color={props.color}
      fontFamily={fontFamily}
      whiteSpace={whiteSpace}
      overflow={overflow}
      textOverflow={textOverflow}
      textDecoration={textDecoration}
      fontWeight={fontWeight}
      lineHeight={lineHeight}
      hoverStyle={hoverStyle}
      onClick={props.onClick}
      textCase={props.textCase}
      cursor={cursor}
      wordBreak={wordBreak}
      display={props.display}
      lineClamp={props.lineClamp}
      data-testid={props.dataTestId}
    >
      {props.children}
    </BaseText>
  );
}

export default React.memo(Text);
